// extracted by mini-css-extract-plugin
module.exports = {"AddDocumentsModalButton":"AddNewsDocumentsModal_AddDocumentsModalButton__1Q3Wl","AddDocumentsModal":"AddNewsDocumentsModal_AddDocumentsModal__3nOJ3"};